// extracted by mini-css-extract-plugin
export var contrastLow = "_2k-1";
export var externalLink = "_2k-2";
export var externalLinkIcon = "_2k-3";
export var link = "_2k-0";
export var linkLabel = "_2k-4";